import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ClientState } from "./client.reducer";


export const selectClientState = createFeatureSelector<ClientState>('client')

export const selectClient = createSelector(
    selectClientState,
    (data: ClientState) => data.client
)

export const selectClientTokensLeft = createSelector(
    selectClientState,
    (data:ClientState) => data.token_left
)

export const selectClientTokensPerMonth = createSelector(
    selectClientState,
    (data:ClientState) => data.token_per_month
)

export const selectClientPlan = createSelector(
    selectClientState, 
    (data:ClientState) => data.plan
)

export const selectClientIsSubscribed = createSelector(
    selectClientState, 
    (data:ClientState) => data.plan?.name !== 'Starter'
)